import { toast } from 'react-toastify'
import { storeWrapper } from '../storeWrapper'

const initialState = {
  toasts: [],
  isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true
}

export const useToastStore = storeWrapper('useToastStore', (set, get) => ({
  ...initialState,
  setIsOnline: (isOnline) => set({ isOnline }),
  showToast: ({
    type = 'success',
    text,
    title,
    actions = [],
    clientMatterNo,
    highlight = '',
    autoClose = 6000,
    closeOnClick = true,
    closeButton,
    id
  }) => {
    const toast = { type, text, actions, title, clientMatterNo, highlight, autoClose, closeOnClick }
    if (closeButton === false) {
      toast.closeButton = false
      toast.closeOnClick = false
    }

    if (id) toast.id = id

    const existingToasts = get().toasts
    set({ toasts: [...existingToasts, toast] })
  },
  reset: () => {
    set({ toasts: [] })
    toast.dismiss()
    set(initialState)
  }
}))
